import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';

import Input from '../shared/Input';
import Drawer from '../shared/Drawer';
import Autocomplete from '../shared/Autocomplete';

import userRoles from '../../constants/userRoles';

const HospitalModal = (props) => {
  const {
    mode = 'create',
    open,
    onClose,
    onSubmit,
    loading,
    companies = [],
    // countries = [],
    currentUser,
    initialValues,
  } = props;

  const [name, setName] = useState('');
  const [company, setCompany] = useState(null);
  const [address, setAddress] = useState('');
  const [state, setState] = useState('');
  const [postCode, setPostCode] = useState('');
  const [country, setCountry] = useState(null);

  useEffect(() => {
    if (open && mode === 'create' && currentUser?.role === userRoles.COUNTRY_ADMIN.name) {
      setCompany(companies?.find((c) => c.id === currentUser.company));
    }
    if (open && mode === 'update') {
      setName(initialValues?.name || '');
      setCompany(initialValues?.company ? companies?.find((c) => c.id === initialValues.company) : null);
      setAddress(initialValues?.address || '');
      setCountry(initialValues?.country || '');
      setState(initialValues?.state || '');
      setPostCode(initialValues?.postCode || '');
    }
  }, [open, mode, initialValues, companies, currentUser]);

  const resetValues = () => {
    setName('');
    setCompany(null);
    setCountry(null);
    setAddress( '');
    setState('');
    setPostCode('');
  };

  const handleSubmit = async () => {
    const formObj = {
      name: name || '',
      company: company?.id || null,
      address,
      country,
      state,
      postCode,
    };
    await onSubmit(formObj);
    resetValues();
  };

  const isDisabled = () => {
    return !name || !company || !country;
  };

  return (
    <Drawer
      open={open}
      onClose={() => {
        resetValues();
        onClose();
      }}
      title={mode === 'update' ? 'Edit Hospital' : 'Create Hospital'}
      subtitle="Enter hospital details"
      submitText={mode === 'update' ? 'Save Changes' : 'Create'}
      disabled={isDisabled()}
      loading={loading}
      onSubmit={handleSubmit}
    >
      <Box sx={{ minWidth: { xs: 'auto', md: '560px' } }}>
        <Grid container spacing={1} sx={{ maxWidth: '600px' }}>
          {currentUser?.role === userRoles.GLOBAL_ADMIN.name && (
            <Grid size={{ xs: 12 }}>
              <Autocomplete
                value={company}
                onChange={(value) => {
                  setCompany(value);
                  setCountry(null);
                }}
                getOptionLabel={(option) => option.name || ''}
                options={companies}
                label="Company"
                required
              />
            </Grid>
          )}
          <Grid size={{ xs: 12 }}>
            <Autocomplete
              value={country}
              onChange={setCountry}
              options={company?.countries?.filter((country) => currentUser?.role === userRoles.GLOBAL_ADMIN.name || currentUser?.administrationCountries?.includes(country)) || []}
              label="Country"
              required
            />
          </Grid>
          <Grid size={{ xs: 12 }}>
            <Input
              id="name"
              type="text"
              placeholder=""
              value={name}
              onChange={(e) => setName(e.target.value)}
              label="Hospital Name"
              required
            />
          </Grid>
          <Grid size={{ xs: 12 }}>
            <Input
              id="address"
              type="text"
              placeholder=""
              value={address}
              onChange={(e) => setAddress(e.target.value)}
              label="Address"
            />
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <Input
              id="state"
              type="text"
              placeholder=""
              value={state}
              onChange={(e) => setState(e.target.value)}
              label="State"
            />
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <Input
              id="postCode"
              type="text"
              placeholder=""
              value={postCode}
              onChange={(e) => setPostCode(e.target.value)}
              label="Post Code"
            />
          </Grid>
        </Grid>
      </Box>
    </Drawer>
  );
};

HospitalModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  onSubmit: PropTypes.func,
};

export default HospitalModal;
